module.exports = __webpack_public_path__ + "components/country-flag/static/ai-7b7880ad6142b80497b02333edcd177e.svg";